export default __webpack_public_path__ + "static/media/teachable-feeds-cover.2424e214.png";